import ActionCompleteBlock, { ActionCompleteBlockProps } from './ActionCompleteBlock';
import withInteractor from './ActionCompleteBlock.interactor';
import withPresenter from './ActionCompleteBlock.presenter';
export type { ActionCompleteBlockProps };
export default withInteractor(withPresenter(ActionCompleteBlock));
